__turbopack_context__.v({
  "dropdown": "LocationPicker-module-scss-module__pruhlW__dropdown",
  "highlight": "LocationPicker-module-scss-module__pruhlW__highlight",
  "item": "LocationPicker-module-scss-module__pruhlW__item",
  "label": "LocationPicker-module-scss-module__pruhlW__label",
  "popoverContainer": "LocationPicker-module-scss-module__pruhlW__popoverContainer",
  "wrapper": "LocationPicker-module-scss-module__pruhlW__wrapper",
});
